module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAfUlEQVR4AWOgD0g/RiSim4b/qODXj3c/Pt/69uHar+9v0aSwaPj98+Pvrw9u3bl86+4lIOPPr88ENPz6/vL92yvd23o7d658/+H+7x/vCGj48/vbs0f7bzw5df3xuefPjv/98wOnBoQl357//nz/9+cHv3+8QZMajPEwKAEAYiIsSQDULGAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/NI.png
// module id = 1228
// module chunks = 0